"use client";

import Link from "next/link";
import { Icon } from "@/components/ui/Icon";
import { motion } from "framer-motion";
import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { LANDING, href } from "./landingDict";

type EnterpriseCTAProps = {
  locale?: Locale;
};

export const EnterpriseCTA = ({ locale = "fr" }: EnterpriseCTAProps) => {
  const t = tr(LANDING, locale).enterprise;
  return (
    <section className="relative w-full bg-white py-16 text-black">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid items-center gap-8 rounded-2xl border border-gold-300/50 bg-white p-8 md:grid-cols-2">
          <div>
            <p className="mb-3 inline-flex rounded-full border border-gold-300 bg-gold-100 px-3 py-1 text-xs font-medium uppercase tracking-[0.14em] text-gold-800">
              {t.eyebrow}
            </p>
            <motion.h3
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.5 }}
              className="mb-3 text-2xl font-semibold tracking-tight text-black md:text-3xl"
            >
              {t.heading}
            </motion.h3>
            <p className="max-w-2xl text-sm leading-6 text-black/75 md:text-base">
              {t.text}
            </p>
          </div>
          <div className="flex flex-wrap gap-3 md:justify-end">
            <Link
              href={href(locale, "/contact")}
              className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 font-semibold text-white transition-colors hover:bg-gold-700"
            >
              {t.ctaContact}
              <Icon icon="mdi:email-edit-outline" />
            </Link>
            <Link
              href={href(locale, "/reservation")}
              className="inline-flex items-center gap-2 rounded-lg border border-black/20 bg-white px-5 py-2.5 font-semibold text-black transition-colors hover:border-gold-500 hover:text-gold-800"
            >
              {t.ctaReserve}
              <Icon icon="mdi:steering" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
